import React, { Component } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { l, BtnV2 } from '@manychat/manyui'

import { isMobile } from 'utils'

import app from '../app'

import cm from './Toolbar.module.css'

export default class FlowChartToolbar extends Component {
  static propTypes = {
    theme: PropTypes.shape({
      toolbar: PropTypes.string,
      btn: PropTypes.string,
    }),
  }

  static defaultProps = {
    theme: {
      toolbar: '',
      btn: '',
    },
  }

  handleAutoArrangeClick = () => {
    app.rearrange()
    if (isMobile) {
      app.fitAllNodes()
    }
  }

  render() {
    const { readonly, className, theme, hideAutoArrange } = this.props

    return (
      <div className={cx(cm.wrapper, className, theme.toolbar)}>
        {Boolean(!readonly && !hideAutoArrange) && (
          <BtnV2
            data-title={l.translate('Auto Arrange Steps')}
            data-title-at="left"
            onClick={this.handleAutoArrangeClick}
            className={cx(cm.btn, theme.btn)}
            onlyIcon="MagicWand"
            ariaLabel={l.translate('Auto Arrange Steps')}
          />
        )}
        <BtnV2
          onClick={app.scaleUp}
          className={cx(cm.btn, theme.btn)}
          data-test-id="flowchart-scale-up-button"
          onlyIcon="Plus"
          ariaLabel={l.translate('Zoom In')}
        />
        <BtnV2
          onClick={app.scaleDown}
          className={cx(cm.btn, theme.btn)}
          data-test-id="flowchart-scale-down-button"
          onlyIcon="Minus"
          ariaLabel={l.translate('Zoom Out')}
        />
      </div>
    )
  }
}
